import React, { useEffect, useRef, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { useRequestHandler } from "../utils/useRequestHandler";
import { useDispatch } from "react-redux";
import { Button } from "@mui/material";

import PronosticarCategoria from "./PronosticarCategoria";
import { showErrorMessage, showSuccessMessage } from "../redux/appSlice";
import Servicios from "../services";
import {
  COMPARSAS,
  HUMORISTAS,
  MURGAS,
  PARODISTAS,
  REVISTAS
} from "../utils/constants";

export const Resultados = () => {
  const { _concursoId } = useParams();
  const [concurso, setConcurso] = useState({});
  const [murgas, setMurgas] = useState([]);
  const [parodistas, setParodistas] = useState([]);
  const [humoristas, setHumoristas] = useState([]);
  const [revistas, setRevistas] = useState([]);
  const [comparsas, setComparsas] = useState([]);
  const sendRequest = useRequestHandler();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleGuardar = () => {
    // Revisión H-6: la base guarda el puntaje como entero. Un puntaje con
    // decimales no se trunca: se avisa y no se guarda.
    const conDecimales = [murgas, parodistas, humoristas, revistas, comparsas]
      .flat()
      .filter(x => x && !Number.isInteger(Number(x.puntosObtenidos)));
    if (conDecimales.length > 0) {
      dispatch(
        showErrorMessage(
          `Puntaje con decimales en ${conDecimales.map(x => x.nombre).join(", ")}: hoy solo se guardan enteros. No se guardó nada.`
        )
      );
      return;
    }
    sendRequest(
      Servicios.GuardarResultadosConcurso,
      [_concursoId, { murgas, parodistas, humoristas, revistas, comparsas }],
      () =>
        dispatch(
          showSuccessMessage(
            // M1-114: en "Resultados disponibles" la penca no se recalcula sola.
            "Resultados guardados. Si el concurso ya tiene resultados disponibles, recalculá la penca desde Cambiar estado."
          )
        )
    );
  };

  useEffect(() => {
    sendRequest(Servicios.ObtenerResultadosConcurso, [_concursoId], data => {
      setConcurso(data?.data);
      setMurgas(
        data?.data?.murgas?.length > 0
          ? data?.data?.murgas
          : data?.data?.conjuntos?.filter(
              x => x.categoria == MURGAS && x.clasificadoLiguilla
            )
      );
      setParodistas(
        data?.data?.parodistas?.length > 0
          ? data?.data?.parodistas
          : data?.data?.conjuntos?.filter(
              x => x.categoria == PARODISTAS && x.clasificadoLiguilla
            )
      );
      setHumoristas(
        data?.data?.humoristas?.length > 0
          ? data?.data?.humoristas
          : data?.data?.conjuntos?.filter(
              x => x.categoria == HUMORISTAS && x.clasificadoLiguilla
            )
      );
      setRevistas(
        data?.data?.revistas?.length > 0
          ? data?.data?.revistas
          : data?.data?.conjuntos?.filter(
              x => x.categoria == REVISTAS && x.clasificadoLiguilla
            )
      );
      setComparsas(
        data?.data?.comparsas?.length > 0
          ? data?.data?.comparsas
          : data?.data?.conjuntos?.filter(
              x => x.categoria == COMPARSAS && x.clasificadoLiguilla
            )
      );
    });
  }, [_concursoId]);

  return (
    <>
      <div className="card-modern">
        <div className="flex items-center justify-between m-2">
          <div className="page-header">
            <h4 className="page-title">{`Cargar resultados de concurso`}</h4>
          </div>
        </div>

        <hr className="border-gray-200 dark:border-gray-700 my-4" />
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div>
            <PronosticarCategoria
              title="Murgas"
              conjuntos={murgas}
              setConjuntos={setMurgas}
              disabled
              conPosicionActa
            />
          </div>
          <div>
            <PronosticarCategoria
              title="Parodistas"
              conjuntos={parodistas}
              setConjuntos={setParodistas}
              disabled
              conPosicionActa
            />
          </div>
          <div>
            <PronosticarCategoria
              title="Humoristas"
              conjuntos={humoristas}
              setConjuntos={setHumoristas}
              disabled
              conPosicionActa
            />
          </div>
          <div>
            <PronosticarCategoria
              title="Revistas"
              conjuntos={revistas}
              setConjuntos={setRevistas}
              disabled
              conPosicionActa
            />
          </div>
          <div>
            <PronosticarCategoria
              title="Comparsas"
              conjuntos={comparsas}
              setConjuntos={setComparsas}
              disabled
              conPosicionActa
            />
          </div>
        </div>
        <hr className="border-gray-200 dark:border-gray-700 my-4" />
        <div className="flex justify-between w-full">
          <div className="text-start">
            <Button
              variant={"outlined"}
              onClick={() => {
                navigate("/Concursos");
              }}
            >
              Cancelar
            </Button>
          </div>
          <div className="text-end">
            <Button variant={"contained"} onClick={handleGuardar}>
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuthenticationRequired(Resultados, {
  onRedirecting: () => <Loading />
});
